// component
import Iconify from '../../components/Iconify'

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />

const startupAdminSidebarConfig = [
  {
    title: 'داشبورد',
    path: '/startup/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
    key: 'DASHBOARD',
  },
  {
    title: 'تایید طرح ها',
    path: '/startup/dashboard/startup-verification/list',
    icon: getIcon('ion:rocket-sharp'),
    key: 'STARTUP_VERIFICATION',
  },
  {
    title: 'مدیریت طرح ها',
    path: '/startup/dashboard/manage-startup/list',
    icon: getIcon('el:idea-alt'),
    key: 'MANAGE_STARTUP',
  },
  {
    title: 'تیکت پشتیبانی',
    path: '/startup/dashboard/ticket/list',
    icon: getIcon('ant-design:message-filled'),
    key: 'TICKET',
  },
  {
    title: 'تایید اخبار',
    path: '/startup/dashboard/news/list',
    icon: getIcon('fluent:news-20-filled'),
    key: 'NEWS',
  },
  {
    title: 'تنظیمات',
    path: '/startup/dashboard/setting',
    icon: getIcon('ant-design:setting-filled'),
    key: 'SETTING',
  },
]

export default startupAdminSidebarConfig
